import { cloneNode, getId, on, removeAttribute, setText } from "@acng/frontend-bounty";
import { Element, Text, isInstanceOf } from "@acng/frontend-bounty/types";
import { RENDERED_ELEMENTS, RENDERED_TEXTNODES } from "../model/resource.js";
/**
 * @param {HTMLTemplateElement} resource
 * @param {Record<string, unknown>} params
 */
export const render = (resource, params) => {
    const template = /** @type {import("../model/resource.js").RenderedResourceElement} */ (cloneNode(resource));
    template[RENDERED_ELEMENTS] = {};
    template[RENDERED_TEXTNODES] = {};
    renderChildNodes(template, template.content, params);
    return template;
};
/**
 * @param {import("../model/resource.js").RenderedResourceElement} template
 * @param {ParentNode} parentNode
 * @param {{[key: string]: unknown}} params
 */
const renderChildNodes = (template, parentNode, params) => {
    for (const childNode of parentNode.childNodes) {
        if (isInstanceOf(childNode, Text)) {
            renderTextNode(template, childNode, params);
        }
        else if (isInstanceOf(childNode, Element)) {
            renderElement(template, childNode, params);
        }
    }
};
/**
 * @param {import("../model/resource.js").RenderedResourceElement} template
 * @param {Text} textNode
 * @param {Record<string, unknown>} params
 */
const renderTextNode = (template, textNode, params) => {
    const match = /^\${([^}]*)}$/.exec(textNode.textContent ?? "");
    if (match) {
        const key = match[1];
        template[RENDERED_TEXTNODES][key] = textNode;
        if (params[key]) {
            setText(textNode, `${params[key]}`);
        }
    }
};
/**
 * @param {import("../model/resource.js").RenderedResourceElement} template
 * @param {Element} element
 * @param {Record<string, unknown>} params
 */
const renderElement = (template, element, params) => {
    const id = getId(element);
    if (id) {
        template[RENDERED_ELEMENTS][id] = element;
        removeAttribute(element, "id");
    }
    for (const { name, value } of element.attributes) {
        const match = /^on:(.*)/.exec(name);
        if (match) {
            const [, eventName] = match;
            const listener = params[value || eventName];
            DEBUG: if (typeof listener !== "function") {
                console.error("listener is not a function");
                continue;
            }
            if (listener) {
                on(element, eventName, /** @type {any} */ (listener.bind(params)));
            }
        }
    }
    renderChildNodes(template, element, params);
};
